module.exports = __webpack_public_path__ + "img/Banner_dashboard.d3b26c0a.svg";